module.exports = __webpack_public_path__ + "static/media/image2.b694704a.jpg";